export const BRAND_COLORS = {
  // Primary Colors
  darkGreen: '#257D69',
  blue: '#537087',
  red: '#F37F6E',

  // Secondary Colors
  lightGreen: '#25A186',
  yellow: '#FBBC65',
  darkRed: '#9B1C1C',
  ashGreen: '#E8F0EE',

  // Neutrals
  black: '#262626',
  lightGray: '#E2E1E3',
  darkGray: '#4B4B4B',
  stroke: '#D0CDD0',
  darkStroke: '#938D8D',
  white: '#FFFFFF',
  dirtyWhite: '#F6F6F6',
};
